/** track-remap のビルド成果物（public/vendor/track-remap に配置） */
const VENDOR_BASE =
  (import.meta.env.VITE_TRACK_REMAP_VENDOR_BASE as string | undefined)?.replace(/\/$/, '')
  ?? '/vendor/track-remap';

export const TRACK_REMAP_SCRIPT_URL = `${VENDOR_BASE}/track-remap.min.js`;
export const TRACK_REMAP_IMAGE_WORKER_URL = `${VENDOR_BASE}/track-remap-image-worker.js`;
export const TRACK_REMAP_FIT_WORKER_URL = `${VENDOR_BASE}/track-remap-worker.js`;
